'use strict';

var ROMAnalysisAllFiltersFactory = function ROMAnalysisAllFiltersFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['ROMNonStopFilterFactory', 'ROMServicesFilterFactory', 'ROMServiceTypeFilterFactory', 'ROMAnalysisCabinFilterFactory', 'ROMOptGroupWeekFilterFactory', 'ROMAnalysisPOSFilterFactory', 'ROMAnalysisFilterByPaxGridBrushFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function ROMAnalysisAllFilters() {
    DemandFilter.call(this, ['rom-analysis-flattened-services-mode', 'rom-analysis-loco-mode', 'rom-analysis-demand-pax-mode'], ['trend-chart-dow', 'trend-chart-dtd', 'rom-loco-table', 'loco-fare-heatmap', 'rom-demand-pax-actual-optimal']);
    this.registerFilters(injectedFilters);
  }
  ROMAnalysisAllFilters.constructor = ROMAnalysisAllFilters;
  ROMAnalysisAllFilters.prototype = Object.create(DemandFilter.prototype);
  ROMAnalysisAllFilters.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType.indexOf(targetType) !== -1;
  };
  return ROMAnalysisAllFilters;
};
ROMAnalysisAllFiltersFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = ROMAnalysisAllFiltersFactory;